import { SupabaseInsightKeyFieldsViewService } from "../../../../modules/insights/server/supabase-insight-key-field-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";

import type { InsightKeyFieldWithData } from "../../../../modules/insights/server/supabase-insight-key-field-service";

interface EngagementBreakdownFields {
  data: InsightKeyFieldWithData[];
  error: Error | null;
  loading: boolean;
}

export const useEngagementBreakdownFields = (): EngagementBreakdownFields => {
  const { data, error, loading } = useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data: fieldsData, error: fieldsError } = await new SupabaseInsightKeyFieldsViewService(
      supabase,
    ).getAll(account_id, {
      order: [{ column: "created_at" }],
    });

    if (fieldsError) throw fieldsError;

    return fieldsData ?? [];
  }, []);

  return { data: data ?? [], error, loading };
};
